<div class="flex flex-col min-h-screen w-full">
  <main
    class="flex-1 w-full relative overflow-hidden bg-main-blue-light flex items-center justify-center"
  >
    <!-- Decorative sport images (mirroring hero section aesthetic) -->
    <img
      src="hero_image/football.png"
      alt=""
      aria-hidden="true"
      class="absolute -bottom-6 -left-8 w-40 md:w-60 opacity-20 rotate-[-15deg] pointer-events-none select-none animate-move-in-right"
    />
    <img
      src="hero_image/basketball.png"
      alt=""
      aria-hidden="true"
      class="absolute -top-4 -right-6 w-36 md:w-52 opacity-20 rotate-[20deg] pointer-events-none select-none animate-move-in-left"
    />
    <img
      src="hero_image/tennis.png"
      alt=""
      aria-hidden="true"
      class="absolute bottom-16 right-8 w-24 md:w-36 opacity-15 rotate-[10deg] pointer-events-none select-none"
    />

    <!-- Main content -->
    <div
      class="relative z-10 flex flex-col items-center justify-center text-center px-6 py-20 gap-6"
    >
      <!-- 404 number -->
      <div class="animate-fade-in-down">
        <span
          class="text-[120px] md:text-[180px] font-bold leading-none text-white opacity-90 drop-shadow-[0_4px_24px_rgba(0,0,0,0.25)]"
        >
          404
        </span>
      </div>

      <!-- Divider pill -->
      <div class="animate-fade-in-down-delay-1 w-16 h-1.5 rounded-full bg-white opacity-70"></div>

      <!-- Heading -->
      <h1
        i18n="not-found|Oops! Page Not Found title@@not-found.oopsTitle"
        class="animate-fade-in-up text-2xl md:text-4xl font-bold text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.2)]"
      >
        Oops! Page Not Found
      </h1>

      <!-- Sub-text -->
      <p
        i18n="not-found|Oops! Page Not Found subtitle@@not-found.pageNotFoundTitle"
        class="animate-fade-in-up-delay-1 text-white/80 text-base md:text-lg max-w-md leading-relaxed"
      >
        The page you're looking for doesn't exist or has been moved. Let's get you back on track!
      </p>

      <!-- CTA button -->
      <div class="animate-fade-in-up-delay-2">
        <a
          routerLink="/"
          class="inline-flex items-center gap-2 bg-white text-main-blue-light font-semibold text-sm md:text-base px-8 py-3 rounded-full shadow-md hover:bg-main-yellow hover:text-white transition-all duration-300 active:scale-95 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
          </svg>
          <span i18n="not-found|Back to Home button@@not-found.backToHomeTitle">Back to Home</span>
        </a>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
